<!-- 主页 -->
<template>
  <div
    class="home"
    v-loading="loading"
  >
    <component
      :is="componentId"
      :propsData="propsData"
    />
    <div class="top-aside">
      <div class="aside-item" @click="toWebsite()">产品介绍</div>
      <div class="aside-item" @click="rulesView()">活动规则</div>
    </div>
    <div class="button-box" v-if="componentId === 'NoAuth'">
      <div class="register-btn" @click="becomePartner">
        获取专属链接
      </div>
    </div>
    <ProtocolModal
      ref="protocol"
      @confirm="agreeAdd"
    />
    <WelcomeModal
      ref="welcome"
    />
    <RegisteredSheet
      ref="registered"
      @onSuccess="toAuth"
    />
    <ActivityRule ref="activityRule"></ActivityRule>
  </div>
</template>

<script>
import NoAuth from '@/components/home_components/no_auth'
import Auth from '@/components/home_components/auth'
import { apiGet } from '@/services'
import homeBanner from '@/assets/images/home/homeBanner.png'
import ProtocolModal from '@/components/home_components/protocolModal'
import WelcomeModal from '@/components/home_components/welcomeModal'
import RegisteredSheet from '@/components/home_components/registeredSheet'
import Cookie from 'js-cookie'
import ActivityRule from '@/views/activity/index.vue'

export default {
  name: 'home-page',
  components: { NoAuth, Auth, ProtocolModal, WelcomeModal, RegisteredSheet, ActivityRule },
  data() {
    return {
      propsData: {},
      homeBanner,
      loading: false,
      componentId: 'NoAuth'
    }
  },
  beforeRouteEnter(to, from, next) {
    if (Cookie.get('helper_tk')) {
      apiGet('partner/open/home')
      .then(res => {
        if (res.code === '0000') {
          // 手机号是不是验证过，没有
          if (res.data.phoneVerify === 0) {
            next(vm => {
              vm.$nextTick(() => {
                vm.$refs.registered.show = true
              })
            })
          } else if (res.data.isAgree === 1) { // 有
            next(vm => {
              vm.propsData = res.data
              vm.componentId = 'Auth'
              vm.$store.commit('set_userInfo', res.data)
              vm.clearUrlQuery()
            })
          } else {
            next(vm => {
              vm.beforeToAuth()
            })
          }
        } else {
          next(vm => {
            if (res.code !== '1002' && res.code !== 'partner_0001') {
              vm.$nextTick(() => {
                vm.$notify.error(res.msg)
              })
            }
            vm.componentId = 'NoAuth'
          })
        }
      }).catch(() => next())
    } else {
      next()
    }
  },
  mounted() {
    this.getAppInfo()
    this.clearUrlQuery()
  },
  watch: {
    componentId: {
      handler(val) {
        if (val === 'NoAuth') {
          this.$parent.showNavBar = false
        } else {
          this.$parent.showNavBar = false
        }
      },
      immediate: true
    }
  },
  methods: {
    getAppInfo() {

    },
    becomePartner() {
       this.toAuth('become')
    },
    toWebsite() {
      window.open('https://www.photonpay.com/')
    },
    rulesView() {
      this.$refs.activityRule.show = true
    },
    // 同意成为合伙人
    agreeAdd() {
      this.loading = true
      apiGet('partner/open/addPartner')
      .then(res => {
        if (res.code === '0000') {
          this.toAuth()
        } else {
          this.$notify.error(res.msg)
        }
      }).then(this.loading = false)
    },
    // 点击合伙人弹窗
    beforeToAuth() {
      this.$nextTick(() => {
        this.$refs.protocol.show = true
      })
    },
    // 获取个人信息
    toAuth(type) {
      this.loading = true
      apiGet('partner/open/home')
      .then(res => {
        if (res.code === '0000') {
          // 手机号是不是验证过，没有
          if (res.data.phoneVerify === 0) {
            this.$nextTick(() => {
              this.$refs.registered.show = true
            })
          } else if (res.data.isAgree === 1) { // 有
            this.propsData = res.data
            this.componentId = 'Auth'
            this.$store.commit('set_userInfo', res.data)
            this.clearUrlQuery()
          } else {
            this.beforeToAuth()
          }
        } else {
          if (res.code !== '1002' && res.code !== 'partner_0001') {
            this.$notify.error(res.msg)
          }
          this.componentId = 'NoAuth'
          if (type === 'become') {
            this.$nextTick(() => {
              this.$refs.registered.show = true
            })
          }
        }
      }).finally(() => (this.loading = false))
    },

    // 清空路由
    clearUrlQuery() {
      this.$nextTick(() => {
        window.history.replaceState(null, null, '/')
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .home {
    background-color: #E9FBFF;
    position: relative;
  }
  .home-banner {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .top-aside{
    width: 48px;
    position: fixed;
    left: 0;
    top: 150px;
    .aside-item{
      box-sizing: border-box;
      background: rgba(187,243,255,0.70);
      border-radius: 4px;
      font-size: 12px;
      text-align: right;
      color: #5c288d;
      line-height: 16px;
      margin-bottom: 12px;
      padding: 2px 5px 2px 15px;
    }
  }
  .register-btn{
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100vw - 30px);
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-weight: 600;
    color: #302B3E;
    background: #ffb600;
    border-radius: 25px;
  }
  .foot-title-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .foot-title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:13px;
      color: rgba(255, 255, 255, 0.6);
      padding-bottom: 24px;
      &::after, &::before {
        content: '';
        display: block;
        width:32px;
        height:1px;
        background:linear-gradient(270deg,rgba(238,238,238,0) 0%,rgba(216,216,216,1) 100%);
        opacity:0.3;
        margin-left: 8px;
      }
      &::before {
        margin: 0;
        margin-right: 8px;
        transform: rotateY(180deg);
      }
    }
  }
  .partner-btn-box {
    display: flex;
    justify-content: center;
    padding-top: 24px;
    .partner-btn {
      text-align: center;
      line-height: 50px;
      width: 321px;
      font-size: 20px;
      color: #121212;
      height: 50px;
      // background: url(~@/assets/images/home/partner.png) no-repeat;
      background: #ffdd3f;
      border-radius: 27px;
      background-size: contain;
      &.fix-btn {
        position: fixed;
        bottom: 24px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  // 兼容iphone x
  @media screen and (width: 375px) and (height: 724px){
    .fix-btn {
        bottom: 34px !important;
    }
  }

  // 兼容iphone xr  xrmax
  @media screen and (width: 414px) and (height: 808px){
    .fix-btn {
        bottom: 34px !important;
    }
  }
</style>
